import styled from 'styled-components';
import {image} from '../../../component/newPopup/popUpWithHeader/colorAndImageTitle/ColorAndImageTitle.css';
import {BGImageCenter, DEFAULT_COLOR, ROYAL_BLUE, VERY_VERY_LIGHT_GRAY, WHITE} from '../../../globalVariables/GlobalVariables';
import {tickchakLogo} from '../../../assets/symbols/images/Images.css';
import {dFlex, dFlexCenter, dFlexColumn, justifyBetween, justifyEnd} from '../../../globalVariables/GlobalFlex';
import {tableContainer} from '../../../component/newTable/Table.css';
import {plus} from '../../../layout/plusIconToPop/PlusIconToPop.css';
import {crowdSearchImageMobile} from '../../../assets/icons/crowdSearchimageMobile';

export const popupWrapper = styled.div`
    ${image}{
        background-size: contain;
        margin-top: -45px;
    }
    ${plus}{
        ${BGImageCenter(crowdSearchImageMobile,'35px')}
        background-color: ${WHITE};
        border: 2px solid ${DEFAULT_COLOR};
        border-radius: 50%;
    }
`;
export const container = styled.div`
    margin-top: 15px;
    overflow: hidden;
    max-height: 100%;
    height: 500px;
    ${dFlexColumn}
    gap: 15px;

`;
export const searchInput = styled.div<{$icon: string}>`
    position: relative;
    ${dFlexCenter}
    height: 40px;
    border-radius: 38px;
    padding-inline: 15px;
    margin-inline: 30px;
    background: ${VERY_VERY_LIGHT_GRAY};
    &::after{
        content: "";
        position: absolute;
        width: 20px; 
        height: 20px;
        cursor: pointer;
        inset-inline-end: 15px;
        top:calc(50% - 10px);
        ${p=>BGImageCenter(p.$icon,'14px')}
        background-position: ${props=>props.theme.rtl?'left ':'right '} center;
  }
  input{
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
  }
`;

export const resultTitle = styled.div`
    text-align: right;
    font-size: 18px;
    font-weight: 700;
    margin-right: 19px;
    margin-block: 15px;
    margin-inline: 30px;
`;

export const resultContent = styled.div`
    height: calc(100% - 160px);
    padding-inline: 30px;
    ${tableContainer}{
        width: 100%;
    }
`;
export const row = styled.div`
    height: 48px;
    padding-inline: 20px;
    gap: 9px;
    ${dFlexCenter}
    ${justifyBetween}
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
`;
export const crowdName = styled.div`
margin-inline-start: 9px;
    font-size: 12px;
    letter-spacing: 1.8px;
`;
export const cell=styled.div`
        width: fit-content;

`;
export const contentCell = styled.div`
    width: 100%;
    ${dFlex}
    ${cell}{
        width: 50%;
    }
`;
export const placeholderCell = styled.div`
    width: 100%;
`;
export const logo = styled.div`
    border-radius: 50%;
    width: 29px;
    height: 29px;
    background-color: ${DEFAULT_COLOR}1C;
    border: 1px solid ${DEFAULT_COLOR};
    ${BGImageCenter(tickchakLogo, '14px')};
`;

export const boldText = styled.span`
    font-weight: 600;
`;
export const footer = styled.div`
    height: 68px;
    width: 100%;
    padding-block: 15px;
    padding-inline-end: 45px;
    ${dFlexCenter}
    ${justifyEnd}
    border-top: 1px solid #E5E5E5;
`;
export const linkText=styled.span`
    color: ${ROYAL_BLUE};
    letter-spacing: 0.12px;
    text-decoration-line: underline;
    cursor: pointer;
    margin-inline-start:5px;
`;
export const noResultContainer = styled.div`
    height: 100%;
    ${dFlexCenter}
    gap:15px;
    flex-direction: column;
`;
export const noResultTitle = styled.div`
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 2.7px;
`;
export const noResultText = styled.div`
    text-align: center;
    letter-spacing: 2.1px;
`;
